import { utils,ethers } from 'ethers'

import _abi from './abi/orderrouterfactory'

const ERC20OrderRouter__factory = {
    connect: (address:string, signerOrProvider?:any) => new ethers.Contract(address, _abi, signerOrProvider),
    createInterface: () => new utils.Interface(_abi),
    _abi
}

export default ERC20OrderRouter__factory;